// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","divider":"Header_divider__1t-WA","header_option":"Header_header_option__3PPYy"};